<template>
    <!-- Modal -->
    <div class="modal fade" id="assignRiderModalBranch" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="assignRiderLabel">Assign Rider </h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Riders</label>
                        <select class="form-control" v-model="selectedRiderId">
                            <option v-for="rider in riders" v-bind:key="'rider_'+rider.id" v-bind:value="rider.id">
                                {{ rider.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="closeModal">Close</button>
                    <button type="button" :disabled="selectedRiderId===''" v-on:click="skipRiderAssign()"
                            class="btn btn-success">Skip
                    </button>
                    <button type="button" :disabled="selectedRiderId===''" v-on:click="assignRider()"
                            class="btn btn-primary">Assign
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AssignRider",
    props: {
        riders: {
            type: Array,
            required: true
        },
        order: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            selectedRiderId: null
        }
    },
    methods: {
        closeModal() {
            // eslint-disable-next-line no-undef
            $("#assignRiderModalBranch").modal("hide");
        },
        assignRider() {
            if(this.selectedRiderId !== null && this.selectedRiderId !== '') {
                const payload = new URLSearchParams({
                    order_id: this.order.id,
                    status_id: this.$status.READY_FOR_DELIVERY.id,
                    rider_id: this.selectedRiderId
                });
                this.$emit('changeOrderStatus', payload);
                // eslint-disable-next-line no-undef
                $("#assignRiderModalBranch").modal("hide");
                // eslint-disable-next-line no-undef
                $("#branch_order_view_model").modal("hide");
            } else {
                alert('Please select rider');
            }
        },
        skipRiderAssign() {
            const payload = new URLSearchParams({
                order_id: this.order.id,
                status_id: this.$status.READY_FOR_DELIVERY.id
            });
            this.$emit('changeOrderStatus', payload);
            // eslint-disable-next-line no-undef
            $("#assignRiderModalBranch").modal("hide");
            // eslint-disable-next-line no-undef
            $("#branch_order_view_model").modal("hide");
        },
    }
}
</script>

<style scoped>

</style>
